import { createRoute } from '@tanstack/react-router'
import { rootRoute } from '../../__root'
import CaseDetailPage from '../../../pages/CaseDetailPage'

// Dynamic route for case detail view with case ID parameter
export const caseDetailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/client/case/$caseId',
  component: CaseDetailPageWrapper,
})

function CaseDetailPageWrapper() {
  const { caseId } = caseDetailRoute.useParams()
  return <CaseDetailPage caseId={parseInt(caseId, 10)} />
}
